/**
 * When a Befund documentation is rendered in parts, and how far along it is.
 *
 * Split out of `renderInParts` so the export hook can ASK the question (and put
 * the size warning up) without pulling the renderer in: everything that touches
 * @react-pdf is loaded on demand, at the click that starts an export.
 */

/**
 * Above this many descriptions the export switches to rendering in parts. A
 * normal single or selected export stays well below it and takes the plain
 * one-pass path.
 */
export const PARTS_THRESHOLD = 300;

/** Descriptions in an export — what the threshold is measured in. */
export function countDescriptions(data: {
    findings: { descriptions: unknown[] }[];
}): number {
    return data.findings.reduce(
        (sum, finding) => sum + finding.descriptions.length,
        0
    );
}

export interface RenderProgress {
    /** Parts finished, and how many there are. */
    part: number;
    parts: number;
    /** Descriptions covered so far, out of the total. */
    done: number;
    total: number;
}
